import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {AppRoutesModule} from './app.routes';
import {CampusListComponent} from './pages/campus-list/campus-list.component';
import {CampusCardComponent} from './components/campus-card/campus-card.component';
import {EditCampusComponent} from './pages/edit-campus/edit-campus.component';
import {EditCampusAssetbundlesComponent} from './components/edit-campus-assetbundles/edit-campus-assetbundles.component';
import {EditCampusCoverComponent} from './components/edit-campus-cover/edit-campus-cover.component';
import {EditCampusDeleteComponent} from './components/edit-campus-delete/edit-campus-delete.component';
import {EditCampusInformationComponent} from './components/edit-campus-information/edit-campus-information.component';
import {LoadingComponent} from './components/loading/loading.component';
import {YesNoDialogComponent} from './components/yes-no-dialog/yes-no-dialog.component';
import {VumarkToolComponent} from './components/vumark-tool/vumark-tool.component';
import {FormsModule} from '@angular/forms';
import {
  MatBadgeModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatOptionModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatTabsModule,
  MatToolbarModule,
} from '@angular/material';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {GlobalService} from './services/global/global.service';
import {DataLoaderService} from './services/data-loader/data-loader.service';
import {APP_BASE_HREF} from '@angular/common';
import {SiteComponent} from './pages/site/site.component';
import {TopBarComponent} from './components/top-bar/top-bar.component';
import {DataLoaderMockService} from './services/data-loader-mock/data-loader-mock.service';

export function testModule(): NgModule {
  return {
    declarations: [
      AppComponent,
      YesNoDialogComponent,
      CampusListComponent,
      CampusCardComponent,
      EditCampusComponent,
      EditCampusAssetbundlesComponent,
      EditCampusCoverComponent,
      EditCampusDeleteComponent,
      EditCampusInformationComponent,
      LoadingComponent,
      VumarkToolComponent,
      SiteComponent,
      TopBarComponent,
    ],
    imports: [
      BrowserModule,
      FormsModule,
      MatDialogModule,
      MatSnackBarModule,
      MatMenuModule,
      MatChipsModule,
      MatBadgeModule,
      MatIconModule,
      MatButtonModule,
      MatSelectModule,
      MatProgressSpinnerModule,
      MatToolbarModule,
      MatCardModule,
      BrowserAnimationsModule,
      AppRoutesModule,
      RouterModule,
      MatFormFieldModule,
      MatInputModule,
      MatListModule,
      MatCheckboxModule,
      MatSlideToggleModule,
      MatTabsModule,
      MatOptionModule,
      HttpClientModule,
    ],
    providers: [
      YesNoDialogComponent,
      GlobalService,
      {
        provide: DataLoaderService,
        useClass: DataLoaderMockService,
      },
      {
        provide: APP_BASE_HREF,
        useValue: '/',
      },
    ],
    bootstrap: [AppComponent],
    entryComponents: [YesNoDialogComponent],
  };
}

@NgModule({
  declarations: [
    AppComponent,
    YesNoDialogComponent,
    CampusListComponent,
    CampusCardComponent,
    EditCampusComponent,
    EditCampusAssetbundlesComponent,
    EditCampusCoverComponent,
    EditCampusDeleteComponent,
    EditCampusInformationComponent,
    LoadingComponent,
    VumarkToolComponent,
    SiteComponent,
    TopBarComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    MatDialogModule,
    MatSnackBarModule,
    MatMenuModule,
    MatChipsModule,
    MatBadgeModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    BrowserAnimationsModule,
    AppRoutesModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatOptionModule,
    HttpClientModule,
  ],
  providers: [YesNoDialogComponent, GlobalService, DataLoaderService],
  bootstrap: [AppComponent],
  entryComponents: [YesNoDialogComponent],
})
export class AppModule {
}
